import { createSlice } from "@reduxjs/toolkit";

const tabIndexSlice = createSlice({
    name: 'tabIndexSlice',
    initialState: {
        userTabIndex: "1",
        groupTabIndex: "1",
        requestTabIndex: "1",
        rfqsTabIndex: "1",
        vendorTabIndex: "1",
        requestCardTabIndex: '1',
        orderTabIndex: '1',
        orderListTabIndex: '1',
        paymentTabIndex: '1'
    },
    reducers: {
        updateUserTabIndex: (state, action) => { state.userTabIndex = action.payload },
        updateGroupTabIndex: (state, action) => { state.groupTabIndex = action.payload },
        updateRequestTabIndex: (state, action) => { state.requestTabIndex = action.payload },
        updateVendorTabIndex: (state, action) => { state.vendorTabIndex = action.payload },
        updateRequestCardTabIndex: (state, action) => { state.requestCardTabIndex = action.payload },
        updateRfqsTabIndexCardTabIndex: (state, action) => { state.rfqsTabIndex = action.payload },
        updateOrderTabIndex: (state, action) => { state.orderTabIndex = action.payload },
        updateOrderListTabIndex: (state, action) => { state.orderListTabIndex = action.payload },
        updatePaymentTabIndex: (state, action) => { state.paymentTabIndex = action.payload },
    }
})

export const {
    updateUserTabIndex,
    updateGroupTabIndex,
    updateRequestTabIndex,
    updateVendorTabIndex,
    updateRequestCardTabIndex,
    updateRfqsTabIndexCardTabIndex,
    updateOrderTabIndex,
    updateOrderListTabIndex,
    updatePaymentTabIndex
} = tabIndexSlice.actions;

export const tabIndexReducer = tabIndexSlice.reducer